export default __webpack_public_path__ + "locales/ro/SMTPSettings.json?hash=fcb54a31c58d728c99212cc0437bb25c";